const BYPASS_USERS = [
  { email: "test@test.com", name: "Test Viewer", role: "view" },
  { email: "cwh@wvcapital.com", name: "Woody Hubbell", role: "view" },
  { email: "todd.page@data-vault.com", name: "Todd Page", role: "view" },
  { email: "neil.strange@data-vault.com", name: "Neil Strange", role: "view" },
  { email: "phil.mousseau@data-vault.com", name: "Phil Mousseau", role: "view" },
  { email: "risa.pecoraro@business-thinking.com", name: "Risa Pecoraro", role: "view" }
];
export default BYPASS_USERS;
